import {
  apiRequest,
  listEmployeeDatatable,
  listEmployeeTable,
  exportExcel,
  detailBobot,
} from "../../../../../services/adapters/kepegawaian/revisiTunjanganKhususService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      listEmployeeDatatable,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchRapelTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      listEmployeeTable,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchRevisiExport = async (query) => {
    return await apiRequest(
      "get",
      exportExcel,
      {
        params: query,
      },
      true
    );
  };

  fetchDetailBobot = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      detailBobot,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default DataTableRepository;
